//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getShopingBatch, putDeleteCart, GetShopingMatch } from './../../service/index'
export default {
  data () {
    return {
      Item: {Amount: 0, BatchDetails: []}
    }
  },
  components: {},
  created () {
    this.GetShopingMatch()
  },
  mounted () {

  },
  watch: {
    '': function (to, from) {

    }
  },
  methods: {
    GetShopingMatch () {
      let vm = this
      GetShopingMatch(this.$route.params.id, (result) => {
        console.log(JSON.parse(result.data))
        if (result.code === '1') {
          vm.Item = JSON.parse(result.data)
        }
      })
    },
    del (obj, idx) {
      let vm = this
      let params = this.$route.params
      let pData = {
        CartDetails: [{
          BigZDL: 'Z009',
          CarOid: params.cid,
          EntriesOids: [{Oid: obj.OId}]
        }]
      }
      console.log(JSON.stringify(pData))
      putDeleteCart(pData, (result) => {
        if (result.code === '1') {
          vm.Item.TotalQty -= 1
          vm.Item.Amount -= obj.ZJSJE
          vm.Item.BatchDetails.splice(idx, 1)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/shopcart/shopbatch.vue